/** @format */
import { getEnvUrlByUrl } from '@power/runtime-vue3';
import { type CDNModuleName, getDynamicLoadUrl, autoComplete } from '@power/vite-plugin-cdn-import';
import { cdnModulesConfig } from './complete';

export const isCss = (url: string) => url.includes('.css');

export const hasJsOrCss = (url: string) => {
	const obj = isCss(url)
		? {
				type: 'link',
				attr: 'href',
		  }
		: {
				type: 'script',
				attr: 'src',
		  };

	const list = document.documentElement.getElementsByTagName(obj.type);
	return Array.from(list).some((itm) => itm[obj.attr] === url);
};

export const loadScript = (url: string) => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = url;
		script.async = false;
		script.defer = true;

		script.onload = () => {
			resolve(true);
		};

		script.onerror = (error) => {
			reject(error);
		};

		document.body.appendChild(script);
	});
};

export const loadCss = (url: string) => {
	return new Promise((resolve, reject) => {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = url;

		link.onload = () => {
			resolve(null);
		};

		link.onerror = (error) => {
			reject(error);
		};

		document.head.appendChild(link);
	});
};

export const dynamicLoadByUrl = (url: string) => {
	if (!hasJsOrCss(url)) {
		if (isCss(url)) {
			return loadCss(url);
		} else {
			return loadScript(url);
		}
	}
};

export const getCDNLinkPath = () => {
	const url = getEnvUrlByUrl(`${`power-front-base/base/{name}/@next/dist/{path}`}`);
	return `${window.location.origin}${url}`;
};

export const dynamicLoadByName = async (moduleName: CDNModuleName) => {
	if (import.meta.env.VITE_BUILD_FORMAT !== 'umd') {
		const item = cdnModulesConfig[moduleName];
		const module = await item.importLoad?.();

		window[moduleName] = module.default;

		return module.default;
	} else {
		const item = autoComplete(moduleName);

		const config = getDynamicLoadUrl(item, getCDNLinkPath());

		config.css.forEach((url) => {
			dynamicLoadByUrl(url);
		});

		const jsList = config.js.map((url) => dynamicLoadByUrl(url));

		return Promise.all(jsList);
	}
};
